/**
 *
 * @param {string} pageAlias The pageAlias of the current page
 * @param {Object} pageAliasMappings Object containing keys of regex matchers and the desired mappings
 * @returns The pageAlias mapping.
 */
export default (pageAlias = '', pageAliasMappings = []) => {
	const mapping = pageAliasMappings.find(
		({ matcher }) => pageAlias.match(matcher) !== null
	);
	return mapping || {};
};
